// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "div.tabs___1jRYV > ul {\n  background-color: white;\n  top: 0;\n  position: sticky;\n  z-index: 1;\n}\ndiv.tabs___1jRYV div[class*=\"Custom-ETA\"] div[class*=\"rt-tbody\"] div[class*=\"rt-td\"] {\n  max-height: unset;\n}\n", "",{"version":3,"sources":["MehrsprachigkeitFaq.less"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,MAAM;EACN,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB","file":"MehrsprachigkeitFaq.less","sourcesContent":["div.tabs > ul {\n  background-color: white;\n  top: 0;\n  position: sticky;\n  z-index: 1;\n}\ndiv.tabs div[class*=\"Custom-ETA\"] div[class*=\"rt-tbody\"] div[class*=\"rt-td\"] {\n  max-height: unset;\n}\n"]}]);
// Exports
exports.locals = {
	"tabs": "tabs___1jRYV"
};
module.exports = exports;
